import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../button';
import styles from './IconButton.module.scss';

const colorSchemeMap = {
  primary: styles.iconPrimary,
  secondary: styles.iconSecondary,
};

const IconButton = React.forwardRef(
  (
    {
      color = '',
      loading,
      iconLoading: IconLoading,
      iconRegular: IconRegular,
      iconHover: IconHover,
      iconActive: IconActive,
      isActive,
      className,
      ...rest
    },
    ref,
  ) => {
    const buttonRef = React.useRef(ref);

    return (
      <Button
        ref={buttonRef}
        variant="invisible"
        as="pill"
        className={clsx(styles.iconButton, colorSchemeMap[color], isActive && styles.active, className)}
        {...rest}
      >
        {loading && (
          <span className={styles.loading}>
            <IconLoading />
          </span>
        )}
        {!loading && (
          <>
            <span className={styles.regular}>{isActive ? <IconActive /> : <IconRegular />}</span>
            <span className={styles.hover}>
              <IconHover />
            </span>
          </>
        )}
      </Button>
    );
  },
);

IconButton.propTypes = {
  color: PropTypes.oneOf(['secondary', 'primary']),
  iconRegular: PropTypes.func.isRequired,
  iconHover: PropTypes.func.isRequired,
  iconActive: PropTypes.func.isRequired,
  iconLoading: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  loading: PropTypes.bool,
};

IconButton.defaultProps = {
  color: 'secondary',
  isActive: false,
  iconLoading: () => null,
  iconRegular: () => null,
  iconHover: () => null,
  iconActive: () => null,
  loading: false,
};

export default IconButton;
